























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { RedCapital, SelectedCountry, Configuration, TitleTemplatePublic } from '@/configuration'
import API from '@/api'
import { EventBus } from '@/main'
import DniField from '@/components/DniField.vue'
import { isRutValid, DniTrim } from '@/utils'

@Component ({
  metaInfo: {
    title: 'Nueva contraseña',
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    }
  },
  data() {
    return{
      form: {
        dni: '',
        password: '',
        c_password: '',
      },
      validPassword :{
        length: false,
        number: false,
        capital: false
      },
      tries: 0,
      canPress: true,
      valid: false,
      dialog: false,
      showPassword: false,
      showPassword2: false,
      errorMessage: null,
    }
  },
  watch: {
    dni() {
      this.$data.errorMessage = null
      // @ts-ignore
      this.$data.valid = this.$refs.form.validate()
    },
    form: {
      handler(val) {
        // @ts-ignore
        this.$data.valid = this.$refs.form.validate() && (val.password == val.c_password)
      },
      deep: true,
    },
  },
  methods:{
    validate() {
      this.$data.canPress = false,
      API.newPassword(DniTrim.string(this.$data.form.dni), this.$data.form.password, this.$data.form.c_password, this.$props.token).then( res => {
        this.$data.dialog = true
        setTimeout(() => {
          this.$router.push({
            path: '/ingresar'
          })
        }, Configuration.Refresh.Timeout)
      }).catch( error => {
        this.$data.canPress = true
        this.$data.errorMessage = "Revise la información ingresada e intente nuevamente."
        EventBus.$emit('snack-error', error)
        this.$data.tries += 1
        if (this.$data.tries == 3){
          this.$data.errorMessage = "Hubo un error en los registros, intente nuevamente más tarde."
          this.$router.push({
            path: '/recuperar'
          })
        }
      })
    },
    validatePassword(password) {
      // Test length
      this.$data.validPassword.length= password.length >= 6;
      // Test capital
      this.$data.validPassword.capital = /^(?=.*[A-Z]).*$/.test(password);
      // Test number
      this.$data.validPassword.number = /^(?=.*[0-9]).*$/.test(password);

      this.$data.validPassword.symbol = /^(?=.*[!@#$&*]).*$/.test(password);
      return ( 
        this.$data.validPassword.length && 
        this.$data.validPassword.capital && 
        this.$data.validPassword.number &&
        this.$data.validPassword.symbol
    );
  }
  },
  components: {
    DniField
  }
})
export default class NewPassword extends Vue {
  @Prop() token!: string
}
